export default {
  methods: {
    $dt: function (translate) {
      if (typeof translate === "string") {
        return this.$i18n.t(translate);
      } else if (translate === void 0) {
        return this.$i18n.t("loading");
      }
      return (
        translate[this.$i18n.locale] || translate[this.$i18n.fallbackLocale]
      );
    },
  },
};
